/** 后台配置的搜索分类 */
export const categoryList = [
  {
    value: 'engraving',
    label: '雕刻机',
  },
  {
    value: 'electronicSaw',
    label: '电子锯',
  },
  {
    value: 'glassEquip',
    label: '玻璃切割机',
  },
  {
    value: 'fiveSix',
    label: '五六面钻',
  },
  {
    value: 'side',
    label: '侧孔机',
  },
  {
    value: 'ptp',
    label: 'PTP',
  },
  {
    value: 'printTag',
    label: '标签页面',
  },
  {
    value: 'preLayoutSetting',
    label: '预排版设置',
  },
  {
    value: 'baseMaterial',
    label: '原片管理',
  },
  {
    value: 'documentation',
    label: '文档',
  },
  {
    value: 'equipment',
    label: '生产线管理',
  },
  {
    value: 'other',
    label: '其他',
  },
]
